import { HTTP_CALL_BEGIN, HTTP_CALL_END, DARK_MODE, SIDEBAR_COLLAPSED } from "../constants";

export function httpCallBegin() {
  return {
    type: HTTP_CALL_BEGIN,
  };
}

export function toggleDarkMode(checked) {
  return {
    type: DARK_MODE,
    checked
  };
}

export function httpCallEnd() {
  return {
    type: HTTP_CALL_END,
  };
}

export function toggleSideBar() {
  return {
    type: SIDEBAR_COLLAPSED,
  };
}



